if (!customElements.get('jewelry-care-video-player')) {
  customElements.define(
    'jewelry-care-video-player',
    class JewelryCareVideoPlayer extends HTMLElement {
      connectedCallback() {
        this._video = this.querySelector('video');
        this._frame = this.querySelector('.jewelry-care-video__frame');
        this._playBtn = this.querySelector('.jewelry-care-video__btn--play');
        this._pauseBtn = this.querySelector('.jewelry-care-video__btn--pause');
        if (!this._video || !this._frame || !this._playBtn || !this._pauseBtn) return;

        this._video.muted = true;
        this._video.playsInline = true;

        this._handlers = {
          onPlay: () => this._sync(),
          onPause: () => this._sync(),
          onLoaded: () => this._sync(),
          onPlayClick: (e) => {
            e.preventDefault();
            this._video.play().catch(() => {});
          },
          onPauseClick: (e) => {
            e.preventDefault();
            this._video.pause();
          },
          onPlayKey: (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            this._video.play().catch(() => {});
          },
          onPauseKey: (e) => {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            e.preventDefault();
            this._video.pause();
          },
          onFrameClick: (e) => {
            if (e.target && e.target.closest && e.target.closest('.jewelry-care-video__btn')) return;
            e.preventDefault();
            if (this._video.paused) {
              this._video.play().catch(() => {});
            } else {
              this._video.pause();
            }
          }
        };

        this._video.addEventListener('play', this._handlers.onPlay);
        this._video.addEventListener('pause', this._handlers.onPause);
        this._video.addEventListener('loadeddata', this._handlers.onLoaded);
        this._playBtn.addEventListener('click', this._handlers.onPlayClick);
        this._pauseBtn.addEventListener('click', this._handlers.onPauseClick);
        this._playBtn.addEventListener('keydown', this._handlers.onPlayKey);
        this._pauseBtn.addEventListener('keydown', this._handlers.onPauseKey);
        this._frame.addEventListener('click', this._handlers.onFrameClick);

        const p = this._video.play();
        if (p && typeof p.then === 'function') {
          p.then(() => this._sync()).catch(() => this._sync());
        } else {
          this._sync();
        }
      }

      _sync() {
        if (!this._video) return;
        this.setAttribute('data-state', this._video.paused ? 'paused' : 'playing');
        const paused = this._video.paused;
        this._playBtn.setAttribute('tabindex', paused ? '0' : '-1');
        this._pauseBtn.setAttribute('tabindex', paused ? '-1' : '0');
        this._playBtn.setAttribute('aria-hidden', paused ? 'false' : 'true');
        this._pauseBtn.setAttribute('aria-hidden', paused ? 'true' : 'false');
      }

      disconnectedCallback() {
        if (!this._video || !this._handlers) return;
        this._video.removeEventListener('play', this._handlers.onPlay);
        this._video.removeEventListener('pause', this._handlers.onPause);
        this._video.removeEventListener('loadeddata', this._handlers.onLoaded);
        this._playBtn.removeEventListener('click', this._handlers.onPlayClick);
        this._pauseBtn.removeEventListener('click', this._handlers.onPauseClick);
        this._playBtn.removeEventListener('keydown', this._handlers.onPlayKey);
        this._pauseBtn.removeEventListener('keydown', this._handlers.onPauseKey);
        this._frame.removeEventListener('click', this._handlers.onFrameClick);
        this._handlers = null;
      }
    }
  );
}
